import { useTranslate } from '@bynder/localization';
import { useButtonWidgetMutations } from '../../../../../mutations/widgets/button';
import { useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { InputField } from '@bynder/design-system';
import { ButtonWidget } from '../../../../../types';
import { useActiveWidget } from '../../../../../queries/guides';
import { useInspectorStore } from '../../../../../stores/inspectorStore';
import { INSPECTOR_DEBOUNCE_DELAY } from '../../constants';

const LabelEditor = ({ text }: { text: string }) => {
  const { translate } = useTranslate();
  const { editName } = useButtonWidgetMutations();
  const activeWidget = useActiveWidget() as ButtonWidget;
  const widgetSettings = useInspectorStore(s => s.widgetSettings);
  const button = activeWidget?.buttons[widgetSettings?.widgetIndex];

  const [title, setTitle] = useState(
    text || translate('BUTTON_WIDGET.PLACEHOLDER'),
  );

  const onSetTitle = (newTitle: string) =>
    editName.mutate({
      title: newTitle,
      id: button.id,
      buttonIndex: widgetSettings?.widgetIndex,
    });
  const debouncedSetTitle = useDebouncedCallback(
    onSetTitle,
    INSPECTOR_DEBOUNCE_DELAY,
  );

  const handleTitleChange = (value: string) => {
    setTitle(value);
    debouncedSetTitle(value);
  };

  useEffect(() => {
    setTitle(text);
  }, [text]);

  return (
    <InputField
      data-testid="buttonTitle"
      label=""
      placeholder={translate('BUTTON_WIDGET.PLACEHOLDER')}
      value={title}
      onChange={handleTitleChange}
    />
  );
};
export default LabelEditor;
